import React from 'react';
import FooterDelete from './FooterDelete';
import FooterArrow from './FooterArrow';
import './FooterRemoved.css';
import { LinkSet, NullableDepLink } from '../../types';

type Props = {
  removedLinks: LinkSet;
  addedLinks: LinkSet;
  shortenName: (s?: string) => string;
  focusNode: (id: string) => void;
  removeLink: (link: NullableDepLink) => void;
  addLink: (link: NullableDepLink) => void;
};

const FooterRemoved = ({
  removedLinks,
  addedLinks,
  shortenName,
  focusNode,
  removeLink,
  addLink,
}: Props) => (
  <div className="footer-removed">
    {removedLinks.size ? <div className="footer__title">Removed Imports:</div> : null}
    {[...removedLinks]
      .map((linkEntry) => JSON.parse(linkEntry))
      .map(({ parent, child }) => (
        <div className="footer__pill" key={`${parent}-${child}`}>
          <span
            className="footer--clickable"
            onClick={() => focusNode(parent)}
            onKeyPress={() => focusNode(child)}
            role="button"
            tabIndex={0}
          >
            {shortenName(parent)}
          </span>
          <FooterArrow />
          <span
            className="footer--clickable"
            onClick={() => focusNode(child)}
            onKeyPress={() => focusNode(child)}
            role="button"
            tabIndex={0}
          >
            {shortenName(child)}
          </span>
          <FooterDelete
            className="footer--clickable"
            onClick={() => addLink({ parent, child })}
            onKeyPress={() => focusNode(child)}
            role="button"
            tabIndex={0}
          />
        </div>
      ))}
    {addedLinks.size ? <div className="footer__title">Added Imports:</div> : null}
    {[...addedLinks]
      .map((linkEntry) => JSON.parse(linkEntry))
      .map(({ parent, child }) => (
        <div className="Footer-pill" key={`${parent}-${child}`}>
          <span
            className="Footer-clickable"
            onClick={() => focusNode(parent)}
            onKeyPress={() => focusNode(child)}
            role="button"
            tabIndex={0}
          >
            {shortenName(parent)}
          </span>
          <FooterArrow />
          <span
            className="Footer-clickable"
            onClick={() => focusNode(child)}
            onKeyPress={() => focusNode(child)}
            role="button"
            tabIndex={0}
          >
            {shortenName(child)}
          </span>
          <FooterDelete
            className="Footer-clickable"
            onClick={() => removeLink({ parent, child })}
            onKeyPress={() => focusNode(child)}
            role="button"
            tabIndex={0}
          />
        </div>
      ))}
  </div>
);

export default FooterRemoved;
